import React, { useState } from "react";
import { Breakfast } from "content-ui/breakfast/types";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import Button from "components/buttonNew/button";

export const ITEMS_PER_FIRST_PAGE = 9;

type AttendeesListProps = {
  list: Required<Breakfast["attendees"]>;
};

export const AttendeesList = ({ list }: AttendeesListProps) => {
  const { track } = useMixpanelTracking();
  const [itemsList, setItemsList] = useState(
    list.slice(0, ITEMS_PER_FIRST_PAGE)
  );

  const handleShowAll = async () => {
    setItemsList(list);

    await track("Attendees list show all", {
      "Click text": "See more",
    });
  };

  const handleShowLess = async () => {
    setItemsList(list.slice(0, ITEMS_PER_FIRST_PAGE));

    await track("Attendees list show less", {
      "Click text": "Show less",
    });
  };

  return (
    <div className={"flex flex-col"}>
      <h3 className={"mb-[10px] font-bold text-[16px] leading-[130%]"}>
        Attendees
      </h3>
      <ul
        className={"grid grid-cols-1 gap-[20px] md:grid-cols-2 lg:grid-cols-3"}
      >
        {itemsList.map((person) => {
          return (
            <li className={"flex flex-row gap-[10px]"} key={person.id}>
              <div className={"flex flex-col gap-1  text-mono-70"}>
                <p className={"font-bold text-[14px] leading-[130%]"}>
                  {person.name}
                </p>
                {(person.role || person.company) && (
                  <p
                    className={"text-[14px] leading-[130%]"}
                    data-testid={"attendeesList__role"}
                  >
                    {person.role} {person.company && `@ ${person.company}`}
                  </p>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      {itemsList.length < list.length && list.length > ITEMS_PER_FIRST_PAGE && (
        <div className={"mt-[30px] flex w-full items-center justify-center"}>
          <Button
            size={"small"}
            buttonType={"secondary"}
            colour={"black"}
            onClick={handleShowAll}
          >
            See more
          </Button>
        </div>
      )}
      {itemsList.length === list.length &&
        list.length > ITEMS_PER_FIRST_PAGE && (
          <div className={"mt-[30px] flex w-full items-center justify-center"}>
            <Button
              size={"small"}
              buttonType={"secondary"}
              colour={"black"}
              onClick={handleShowLess}
            >
              Show less
            </Button>
          </div>
        )}
    </div>
  );
};
